module.exports = __webpack_public_path__ + "img/711-cabc24.png";